import pluralize from './pluralize'

const isNotEmpty = (v) => {
	return v !== null && v !== undefined && v.trim?.() !== '';
}

export default function timeRange(min = 0, max = 0, minSuffix = 'Month', maxSuffix = 'Month', hideLabel = false, convert = true, minExt = '', maxExt = '') {
	if (String(min).match(/life/i)) return `Life`
	if (String(min).match(/death/i)) return `Death Penalty`
	if (String(min).match(/any/i)) return `Any number of years`


	if (max == 1800 || String(max).match(/life/i)) max = `Life`
	if (min == 1800) return `Life`

	if (min > 11 && convert) {
		min = min / 12
		minSuffix = minSuffix ? 'Year' : null
	}

	if (max > 11 && convert) {
		max = max / 12
		maxSuffix = maxSuffix ? 'Year' : null
	}

	if (max === 0 && maxExt) {
		max = 'Any term of years'
		maxExt = ''
	}

	if (isNotEmpty(min) && minSuffix && typeof min != 'string') {
		min = pluralize(min, minSuffix)
	}
	if (isNotEmpty(max) && maxSuffix && typeof max != 'string') {
		max = pluralize(max, maxSuffix)
	}

	min = min + minExt
	max = max + maxExt

	return [min, max].filter(n => n).join(' - ')
}
